module.exports = __webpack_public_path__ + "img/icon_indi_co2_zh.67dde5d6.svg";